module.exports = __webpack_public_path__ + "img/ABC-COVER.310fd646.png";